export default "__VITE_ASSET__65B1aoA9__"